import Resources from "../../shared/actions/resourcesActions";

export default class MacroResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "macro", "/api/v1/macros");
  }
}
